import { ProjectMetadataRow } from "./project-metadata-row";

interface ProjectTechnicalSheetCardProps {
  coverImage?: string;
  projectTitle: string;
  director: string;
  projectType: string;
}

export function ProjectTechnicalSheetCard({
  coverImage,
  projectTitle,
  director,
  projectType,
}: ProjectTechnicalSheetCardProps) {
  return (
    <div className="border border-[#7846ff] rounded-[10px] overflow-clip h-[373px] w-full">
      <div className="flex flex-col gap-[17px] items-start p-[30px] h-full">
        {/* Cover Image */}
        <div className="h-[173px] w-full rounded-[10px] overflow-hidden bg-[#0C1427]">
          {coverImage ? (
            <img
              src={coverImage}
              alt={projectTitle}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[#888888] text-[14px]">
              Sem imagem
            </div>
          )}
        </div>

        {/* Title */}
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[16px] whitespace-pre">
          Ficha Técnica:
        </p>

        {/* Metadata Rows */}
        <div className="flex flex-col gap-[20px] items-start w-full">
          <ProjectMetadataRow
            label="Título do Projeto:"
            value={projectTitle}
            labelWidth="252px"
            gap="23px"
            size="sm"
            className="w-full"
          />
          <ProjectMetadataRow
            label="Diretor:"
            value={director}
            labelWidth="219px"
            gap="11px"
            size="sm"
            className="w-full"
          />
          <ProjectMetadataRow
            label="Tipo de Projeto:"
            value={projectType}
            labelWidth="271px"
            gap="9px"
            size="sm"
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
}
